const debounce = require('lodash/debounce');
const { clearBodyLocks } = require('tua-body-scroll-lock');

const classHeaderPopUpOpen = 'header--header-popup-open';
const classBodyHeaderPopupOpen = 'header-popup-open';
const classPopupBackdrop = 'popup-backdrop';
const classHeaderPopupShow = 'header-popup--show';
const closeBtnSelector = '.header-popup__btn-close';

const isTouchDevice = () => window.matchMedia('(hover: hover) and (pointer: fine)').matches;
const getHeaderElement = () => document.getElementById('byl-header');
const getBackdropElement = () => document.querySelector(`.${classPopupBackdrop}`);

const handleMinScroll = debounce((evt) => {
  hidePopUp();
  evt.preventDefault();
}, 50);

function addBackdropEvents() {
  if (!isTouchDevice()) return;
  const backDrop = getBackdropElement();
  if (!backDrop) return;
  backDrop.addEventListener('wheel', handleMinScroll);
  backDrop.addEventListener('click', hidePopUp);
  backDrop.addEventListener('touchstart', hidePopUp);
  backDrop.classList.add(`${classPopupBackdrop}--show`);
}

function removeBackdropEvents() {
  if (!isTouchDevice()) return;
  const backDrop = getBackdropElement();
  if (!backDrop) return;
  backDrop.classList.remove(`${classPopupBackdrop}--show`);
  backDrop.removeEventListener('wheel', handleMinScroll);
  backDrop.removeEventListener('click', hidePopUp);
  backDrop.removeEventListener('touchstart', hidePopUp);
}

function hidePopUp() {
  clearBodyLocks();
  removeBackdropEvents();

  document.body.classList.remove(classBodyHeaderPopupOpen);
  getHeaderElement()?.classList.remove(classHeaderPopUpOpen);
  document.querySelector(`.header-popup.${classHeaderPopupShow}`)?.classList.remove(classHeaderPopupShow);
  document.querySelector(closeBtnSelector)?.removeEventListener('click', hidePopUp);
}

function showPopup(event, elementSelector) {
  Array.from(document.querySelectorAll(`.${classHeaderPopupShow}`)).forEach(hidePopUp);

  document.querySelector(`${elementSelector} ${closeBtnSelector}`)?.addEventListener('click', hidePopUp);
  document.querySelector(elementSelector)?.classList.add(classHeaderPopupShow);
  getHeaderElement()?.classList.add(classHeaderPopUpOpen);
  document.body.classList.add(classBodyHeaderPopupOpen);

  addBackdropEvents();
}

module.exports = function init() {
  if (!getHeaderElement()) return;
  $('body').on('header-popup:show', showPopup);
  $('body').on('header-popup:hide', hidePopUp);
};
